{
  "changeLogTitle": "Protokoll ändern",
  "help": {
    "tooltip": "Was wird getrackt",
    "title": "Was wird im Änderungsprotokoll aufgezeichnet",
    "layersCreatedDeleted": "Erstellen und Löschen von Ebenen.",
    "mapObjectsGrouped": "Erstellen, Löschen und Bearbeiten der Geometrie von Kartenobjekten, gruppiert nach Benutzer und Stunde.",
    "mapObjectEditHint": "Einzelne Änderungen an Kartenobjekten gelten als eine Bearbeitung, wenn sie innerhalb von 5 Minuten nacheinander erfolgen.",
    "layerOperationsGrouped": "Operationen zum Kopieren, Importieren und Aufheben der Verknüpfung von Ebenen."
  },
  "dateTimes": {
    "today": "Heute",
    "yesterday": "Gestern",
    "todayAt": "Heute um {{ time }}",
    "yesterdayAt": "Gestern um {{ time }}",
    "dayAt": "{{ day }} um {{ time }}",
    "aWeekAgo": "Vor einer Woche",
    "weekday0": "Sonntag",
    "weekday1": "Montag",
    "weekday2": "Dienstag",
    "weekday3": "Mittwoch",
    "weekday4": "Donnerstag",
    "weekday5": "Freitag",
    "weekday6": "Samstag"
  },
  "labels": {
    "layerFallbackName": "Schicht",
    "multipleLayers": "Mehrere Schichten",
    "viewDetails": "Details anzeigen"
  },
  "subTitles": {
    "layerImported": "Ebene wurde importiert",
    "layersImported": "Importierte Ebenen",
    "layerUnlinked": "Ebene ist nicht verknüpft",
    "layersUnlinked": "Ebenen, die nicht verknüpft sind",
    "layerCopied": "Ebene wurde kopiert",
    "layersCopied": "Ebenen wurden kopiert",
    "layerCreated": "Ebene erstellt",
    "layerDeleted": "Ebene gelöscht",
    "layerEdited": "Ebene bearbeitet"
  },
  "details": {
    "layerImported": "Ebene importiert: {{ layerName }}",
    "layerUnlinked": "Ebene wurde getrennt: {{ layerName }}",
    "layerCreated": "Ebene erstellt: {{ layerName }}",
    "mapObjectCreated": "{{ count }} Kartenobjekt wurde erstellt",
    "mapObjectsCreated": "{{ count }} Kartenobjekte wurden erstellt",
    "mapObjectUpdated": "{{ count }} Kartenobjekt wurde bearbeitet",
    "mapObjectsUpdated": "{{ count }} Kartenobjekte wurden bearbeitet",
    "mapObjectDeleted": "{{ count }} Kartenobjekt wurde gelöscht",
    "mapObjectsDeleted": "{{ count }} Kartenobjekte wurden gelöscht"
  }
}